module.exports = __webpack_public_path__ + "static/w-irfan-m-a57325df14f3df12e44242a52fa4c8dc.png";